/*
 * @Author: 
 * @Date: 2022-03-08 08:50:12
 * @LastEditors: 
 * @LastEditTime: 2022-07-01 17:20:17
 * @FilePath: /Cup2Market/src/utils/index.js
 * @Description: 
 */
// 删除对象中空值
export function removePropertyOfNull(obj) {
  Object.keys(obj).forEach(item => {
    if (obj[item] === null || obj[item] === '') {
      delete obj[item]
    }
  })
  return obj
}
// 获取活动列表中第一张图
export function getFirstGoodsImg(list) {
  if (list.length) {
    const data = list[0]

    if (data.themeGoodsList) {
      return data.themeGoodsList[0]?.goodsImage
    }
    if (data.themeBrandList) {
      if (data.themeBrandList[0].brandGoodsList) {
        return data.themeBrandList[0].brandGoodsList[0]?.goodsImage
      }
    }
    if (data.themeSuitH5List) {
      if (data.themeSuitH5List[0].themeGoodsList) {
        return data.themeSuitH5List[0].themeGoodsList[0]?.goodsImage
      }
    }
    return null
  } else {
    return null
  }
}
// 更好的类型检查
// typeCheck([]); // 'array'
// typeCheck(new Date()); // 'date'
// typeCheck(new String('onepisya')); // 'string'
// typeCheck(2) // 'number'
// typeCheck(new Boolean(true)); // 'boolean'
// typeCheck(null); // 'null'
// typeCheck({}) // 'object'
// typeCheck(undefined) // 'undefined'
export function typeCheck(value) {
  const return_value = Object.prototype.toString.call(value);
  // we can also use regex to do this...
  const type = return_value.substring(
    return_value.indexOf(" ") + 1,
    return_value.indexOf("]"));

  return type.toLowerCase();
}
